(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader) return;

    let menuTimer;
    let hoveringHeader = false;

    const menus = document.querySelectorAll('.header__inline-menu details');

    function updateHeaderState() {
      const hasOpenDetails = stickyHeader.querySelector('details[open]');

      if (hoveringHeader || hasOpenDetails) {
        stickyHeader.classList.add('header-hover');
      } else {
        stickyHeader.classList.remove('header-hover');
      }
    }

    /* Header hover */
    stickyHeader.addEventListener('mouseenter', () => {
      hoveringHeader = true;
      updateHeaderState();
    });

    stickyHeader.addEventListener('mouseleave', () => {
      hoveringHeader = false;

      setTimeout(() => {
        updateHeaderState();
      }, 50);
    });

    /* Mega menu hover */
    menus.forEach(menu => {
      menu.addEventListener('mouseenter', () => {
        clearTimeout(menuTimer);

        menus.forEach(item => {
          if (item !== menu) {
            item.removeAttribute('open');
          }
        });
        menuTimer = setTimeout(() => {
          menu.setAttribute('open', '');
          updateHeaderState();
        }, 100);
      });
      menu.addEventListener('mouseleave', () => {
        clearTimeout(menuTimer);

        menuTimer = setTimeout(() => {
          menu.removeAttribute('open');
          updateHeaderState();
        }, 150);
      });
    });

    /* Search, account, localization etc */
    document.addEventListener(
      'toggle',
      () => {
        updateHeaderState();
      },
      true
    );
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  function initRelatedSwiper() {
    document.querySelectorAll('.related-products-swiper').forEach((slider) => {

      if (slider.classList.contains('swiper-initialized')) return;

      new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 15,

        navigation: {
          nextEl: slider.querySelector('.related-next'),
          prevEl: slider.querySelector('.related-prev'),
        },

        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          990: {
            slidesPerView: 4,
          },
        },
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initRelatedSwiper);
  const observer = new MutationObserver(() => {
    initRelatedSwiper();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  } catch(e) { console.error(e); }
})();
})();
